import React from "react";

const About = () => {
  return (
    <div>
      <h1 className="text-4xl font-bold text-center my-10 mx-4">
        Rick and Morty
      </h1>
      <p className="mx-4 text-lg text-center">
        The series follows the misadventures of cynical mad scientist Rick
        Sanchez and his good-hearted but fretful grandson Morty Smith, who split
        their time between domestic life and interdimensional adventures.
      </p>
    </div>
  );
};

export default About;
